const navBar = document.querySelector('.js-navbar');
const navBarCloseBtn = document.querySelector('.js-navbar-close');
const navBarOpenBtn = document.querySelector('.js-navbar-open');
const navBarMenu = document.querySelector('.js-navbar-menu');
const slideInElements = document.querySelectorAll('.js-slide-in');
const slideInElementsCustom = document.querySelectorAll(
    '.from-left, .from-right'
);

const HIDE_MENU_CLASS = 'translate-x-full';
const OPACITY_CLASS = 'sm:opacity-0';
const WHITE_BG_CLASS = 'bg-white';
const MD_TEXT_WHITE_CLASS = 'md:text-white';
const TEXT_WHITE_CLASS = 'text-white';
const DROP_SHADOW_CLASS = 'drop-shadow-lg';

navBarCloseBtn.addEventListener('click', () => {
    navBarMenu.classList.add(HIDE_MENU_CLASS);
    navBarMenu.classList.add(OPACITY_CLASS);
});

navBarOpenBtn.addEventListener('click', () => {
    navBarMenu.classList.remove(HIDE_MENU_CLASS);
    navBarMenu.classList.remove(OPACITY_CLASS);
});

// if (window.location.pathname === '/') {

// } else {
//     navBar.classList.add(WHITE_BG_CLASS, DROP_SHADOW_CLASS);
//     navBarMenu.classList.remove(MD_TEXT_WHITE_CLASS);
//     navBarOpenBtn.classList.remove(TEXT_WHITE_CLASS);
// }

document.addEventListener('scroll', () => {
    if (document.documentElement.scrollTop > 50) {
        navBar.classList.add(WHITE_BG_CLASS, DROP_SHADOW_CLASS);
        navBarMenu.classList.remove(MD_TEXT_WHITE_CLASS);
        navBarOpenBtn.classList.remove(TEXT_WHITE_CLASS);
    } else {
        navBar.classList.remove(WHITE_BG_CLASS, DROP_SHADOW_CLASS);
        navBarMenu.classList.add(MD_TEXT_WHITE_CLASS);
        navBarOpenBtn.classList.add(TEXT_WHITE_CLASS);
    }
});

const appearOptions = {
    threshold: 0,
    rootMargin: '0px 0px -25px 0px',
};

const appearOnScroll = new IntersectionObserver((entries, appearOnScroll) => {
    entries.forEach((entry) => {
        if (!entry.isIntersecting) {
            return;
        }
        entry.target.classList.remove('opacity-0');
        entry.target.classList.add('translate-x-0', 'opacity-1');
        appearOnScroll.unobserve(entry.target);
    });
}, appearOptions);

const appearOnScrollCustom = new IntersectionObserver(
    (entries, appearOnScroll) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }

            entry.target.classList.add('appear');
            appearOnScroll.unobserve(entry.target);
        });
    },
    appearOptions
);

slideInElements.forEach((element) => appearOnScroll.observe(element));
slideInElementsCustom.forEach((element) =>
    appearOnScrollCustom.observe(element)
);

// If user refreshes page while scrolled, we want to reset navbar
if (document.documentElement.scrollTop > 50) {
    navBar.classList.add(WHITE_BG_CLASS, DROP_SHADOW_CLASS);
    navBarMenu.classList.remove(MD_TEXT_WHITE_CLASS);
    navBarOpenBtn.classList.remove(TEXT_WHITE_CLASS);
}
